import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms'
import { Observable, of, timer } from 'rxjs'
import { catchError, first, map, switchMap } from 'rxjs/operators'
import { GlobalErrorService } from '@services/global-error.service'
import { CertificateHolderService } from '@features/certificate-holder/services/certificate-holder.service'

export function certificateHolderExistsValidator(
  certificateHolderService: CertificateHolderService,
  globalErrorService: GlobalErrorService,
  initialCompanyName: string | null = null,
  initialCountry: string | null = null,
  initialFreetext: string | null = null,
  debounceTimeMs?: number
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const companyName = (control.get('companyName')?.value as string)?.trim()
    const country = control.get('country')?.value as string
    const freetext = (control.get('freetext')?.value as string)?.trim() ?? ''

    if (companyName === null || companyName === undefined ||
      country === null || country === undefined) {
      return of(null)
    }

    if (initialCompanyName !== null && initialCountry !== null && initialFreetext !== null &&
      companyName === initialCompanyName && country === initialCountry && freetext === initialFreetext) {
      return of(null)
    }

    return timer(debounceTimeMs ?? 300).pipe(
      switchMap(() => certificateHolderService.checkCertificateHolderExists(companyName, country, freetext)),
      map(exist => (exist ? { certificateHolderExists: true } : null)),
      catchError(() => {
        globalErrorService.reportError({
          subsystemName: 'Certificate Holder Validator',
          description: 'Could not validate if Certificate Holder exists. Please try again.'
        })
        return of(null)
      }),
      first()
    )
  }
}
